<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link current">パスワード変更</span>
              <span class="breadcrumb-link">パスワード変更の完了</span>
            </div>
            <h1 class="hdg02">パスワード変更</h1>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb12">下記アカウントのパスワードを変更します。</p>
              <p class="txt mb40">対象アカウント：{{group1.name}}</p>
              <h2 class="hdg03">パスワードの変更手続き</h2>
              <ul class="contact-content-list mb0">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th class="pt20">
                          新しいパスワード <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text password formparts-short"
                            :class="{'is-password-mode': group1.isPasswordTypeDisplay}"
                          >
                            <input name="new_password_1" placeholder="新しいパスワード"
                              :type="group1.isPasswordType"
                              v-model="group1.password"
                            >
                            <FontawesomeIcon v-if="group1.isPasswordTypeDisplay" :icon="['far','eye-slash']" size="sm" class="icn"
                              @click="group1.isPasswordTypeDisplay = !group1.isPasswordTypeDisplay"
                            />
                            <FontawesomeIcon v-else :icon="['far','eye']" size="sm" class="icn"
                              @click="group1.isPasswordTypeDisplay = !group1.isPasswordTypeDisplay"
                            />
                          </div>
                          <p class="error-message" v-if="group1.error_password">{{group1.error_password}}</p>
                          <p class="txt">もう一度入力してください</p>
                          <div class="formparts text password formparts-short">
                            <input name="new_password_2" placeholder="新しいパスワード（確認）"
                              :type="group1.isPasswordType2"
                              v-model="group1.password_check"
                            >
                            <FontawesomeIcon v-if="group1.isPasswordTypeDisplay2" :icon="['far','eye-slash']" size="sm" class="icn"
                              @click="group1.isPasswordTypeDisplay2 = !group1.isPasswordTypeDisplay2"
                            />
                            <FontawesomeIcon v-else :icon="['far','eye']" size="sm" class="icn"
                              @click="group1.isPasswordTypeDisplay2 = !group1.isPasswordTypeDisplay2"
                            />
                          </div>
                          <p class="error-message" v-if="group1.error_password_check">{{group1.error_password_check}}</p>
                          <p class="txt-sup">半角英字と数字をどちらも含む8文字以上16文字以下で設定してください。<br>
                          ※記号（ #、@、{ など）も使用いただけます。</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
              <hr class="mb40">
              <div class="contact-submit">
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.submitButtonClicked">変更</button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'

import * as logicPasswordReminder from '@/logic/public/PasswordReminder.js'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicPasswordReminder.getPasswordInput()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
@media screen and (min-width:$width-container + 1) {
  .formparts-short{
    width: 60%;
  }
  hr {
    border-top: 0;
  }
}
</style>
